import * as Models from "../Models";
import * as Common from "../Common/modules";
export interface ICallRecordingApiClient {
  blackoutCallStart(callRecordingRequest: Models.CallRecording.CallRecordingRequest.CallRecordingRequest): ng.IPromise<any>;
  blackoutCallStop(callRecordingRequest: Models.CallRecording.CallRecordingRequest.CallRecordingRequest): ng.IPromise<any>;
  isAuthenticated: () => ng.IPromise<any>;
}

export class CallRecordingApiClient implements ICallRecordingApiClient {
  public static $inject = ['igs.apiClientService'];
  
  constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {
  }

  public blackoutCallStart = (callRecordingRequest: Models.CallRecording.CallRecordingRequest.CallRecordingRequest): ng.IPromise<any> => {
    var config = { errorHandler: () => { } };
    return this.igsApiClientService.post("BlackoutCallStart", callRecordingRequest, config);
  }

  public blackoutCallStop = (callRecordingRequest: Models.CallRecording.CallRecordingRequest.CallRecordingRequest): ng.IPromise<any> => {
    var config = { errorHandler: () => { } };
    return this.igsApiClientService.post("BlackoutCallStop", callRecordingRequest, config);
  }

  public isAuthenticated = (): ng.IPromise<boolean> => {
    return this.igsApiClientService.post("IsAuthenticated/")
}
}
